export default __webpack_public_path__ + "static/media/help--import.aaceb239.png";